import * as actionTypes from '../actions/ActionTypes';
import Config from '../../utils/Configuration';

function initState() {
    if (sessionStorage.getItem(Config.sliceKey.cart)) {
        return {...JSON.parse(sessionStorage.getItem(Config.sliceKey.cart))};
    }
    return {};
}

const initialState = initState();

const updateCartDetails = (state, payload) => {
    const updatedState = {
        ...state,
        ...payload
    };
    sessionStorage.setItem(Config.sliceKey.cart, JSON.stringify(updatedState));
    return updatedState;
};

const getCartDetailsFromApi = (state, payload) => {
    const updatedState = {
        ...state,
        cartDetails: {
            ...state.cartDetails,
            ...payload
        }
    };
    sessionStorage.setItem(Config.sliceKey.cart, JSON.stringify(updatedState));
    return updatedState;
};

const createUpdateCart = (state, payload) => {
    if (payload && payload.cartId) {
        const updatedState = {
            ...state,
            cartId: payload.cartId,
            cartDetails: {
                ...state.cartDetails,
                [payload.cartId]: {...payload}
            }
        };
        sessionStorage.setItem(Config.sliceKey.cart, JSON.stringify(updatedState));
        return updatedState;
    }
    return state;
};

const deleteCart = (state, payload) => {
    const cartDetails = state.cartDetails || {};
    if (payload && payload.cartId) {
        cartDetails[payload.cartId] && delete cartDetails[payload.cartId];
        delete state.cartId;
        delete state.intentionNumber;
        const updatedState = {
            ...state,
            cartDetails
        };
        sessionStorage.setItem(Config.sliceKey.cart, JSON.stringify(updatedState));
        return updatedState;
    }
    return state;
};

const clearCart = (state) => {
    const updatedState = {mobileNumber: state.mobileNumber};
    sessionStorage.setItem(Config.sliceKey.cart, JSON.stringify(updatedState));
    return updatedState;
};

const reducer = (state = initialState, action) => {
    const {payload} = action;
    switch (action.type) {
        case actionTypes.UPDATE_CART:
            return updateCartDetails(state, payload);
        case actionTypes.GET_CART_DETAILS:
            return getCartDetailsFromApi(state, payload);
        case actionTypes.CREATE_CART:
        case actionTypes.UPDATE_CART_DETAILS:
            return createUpdateCart(state, payload);
        case actionTypes.CLEAR:
            return clearCart(state);
        case actionTypes.DELETE_CART:
            return deleteCart(state, payload);
        default:
            return state;
    }
};

export default reducer;
